import { forwardRef } from 'react'
import { useTranslation } from '@front/model'
import { createPolymorphicComponent } from '@mantine/core'
import { TButton, type TButtonProps } from './button'

type ButtonSaveProps = Omit<TButtonProps, 'leftSection' | 'icon'>

const _ButtonSave = forwardRef<HTMLButtonElement, ButtonSaveProps>(({ children, ...props }, ref) => {
  const { t } = useTranslation()
  return (
    <TButton icon='save' variant={props.variant} {...props} ref={ref}>
      {children || t('Save')}
    </TButton>
  )
})

_ButtonSave.displayName = 'ButtonSave'

export const ButtonSave = createPolymorphicComponent<'button', ButtonSaveProps>(_ButtonSave)
